import React from "react";
import { PickList } from "primereact/picklist";

type AssignPickListProps = {
  source: any[];
  target: any[];
  updateStatus?:
    | React.Dispatch<
        React.SetStateAction<{
          availableStatuses: any[];
          currentProductStatuses: any[];
        }>
      >
    | ((value: {
        availableStatuses: any[];
        currentProductStatuses: any[];
      }) => void);
  onChange?: (e: any) => void;
  itemTemplate?: (item: any) => React.ReactNode;
  sourceItemTemplate?: (item: any) => React.ReactNode;
  targetItemTemplate?: (item: any) => React.ReactNode;
  sourceHeader?: React.ReactNode;
  targetHeader?: React.ReactNode;
  sourceHeaderText?: string;
  targetHeaderText?: string;
  dataKey?: string;
  filter?: boolean;
  filterBy?: string;
  style?: React.CSSProperties;
  className?: string;
};

export default function AssignPickList(props: AssignPickListProps) {
  const {
    source,
    target,
    updateStatus = () => {},
    onChange,
    itemTemplate,
    sourceItemTemplate,
    targetItemTemplate,
    sourceHeaderText,
    targetHeaderText,
    dataKey = "id",
    filter = true,
    filterBy = "name",
    style,
    className,
  } = props;

  const handleChange = (e: any) => {
    if (onChange) return onChange(e);

    // keep parent state in sync (supports both setState dispatcher and plain callback)
    updateStatus({
      availableStatuses: e.source,
      currentProductStatuses: e.target,
    });
  };

  return (
    <div className={className}>
      <PickList
        source={source}
        target={target}
        sourceItemTemplate={sourceItemTemplate}
        targetItemTemplate={targetItemTemplate}
        onChange={handleChange}
        sourceHeader={
          <div className="font-medium text-gray-700">{sourceHeaderText}</div>
        }
        targetHeader={
          <div className="font-medium text-gray-700">{targetHeaderText}</div>
        }
        dataKey={dataKey}
        filter={filter}
        filterBy={filterBy}
        style={style ? style : { minHeight: "320px" }}
      />
    </div>
  );
}
